<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Format', apiMethod: 'Formats', form: () => import('../forms/FormatForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Tests', value: 'formatId', table: () => import('../tables/TestsTable') },
                ],
                mainForm: () => import('../forms/FormatForm'),
                claimName: 'Formats',
                apiMethod: 'Formats',
            }
        }
    };
</script>
